import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/platformDict/list',
    method: 'post',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/platformDict/add',
    method: 'post',
    params: obj
  })
}

export function getObj(dictId) {
  return request({
    url: '/platformDict/info',
    method: 'post',
    params: dictId
  })
}

export function delObj(dictId) {
  return request({
    url: '/platformDict/delete',
    method: 'post',
    params: dictId
  })
}

export function putObj(dictId) {
  return request({
    url: '/platformDict/update',
    method: 'post',
    params: dictId
  })
}

export function remote(type) {
  return request({
    url: '/admin/dict/type/' + type,
    method: 'get'
  })
}

export function getDictList(query) {
  return request({
    url: '/dict/getDictList',
    method: 'post',
    params:query
  })
}

export function getDictListById(query) {
  return request({
    url: '/dict/getDictList',
    method: 'get',
    params:query
  })
}
